import React, {useEffect, useRef} from "react"
import axios from "axios"; // TODO - Components which are used by admin as well need to import axios at the moment
import PropTypes from "prop-types"
import AsyncSelect from 'react-select/async';

import { theme, styles } from "@root/Components/Inputs/SelectInput";
import API from "../../../Common/API";

/**
 * Do not use this component, use ResourceSelector instead
 * @todo Perhaps refactor this component to be a simple wrapper for ResourceSelector
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const UnitSelector = (props) => {
    const { multi, onChange, selected, preserveSelectedValues} = props;

    const [ value, setValue ] = React.useState(selected);

    // This is used so that the "preserveSelectedValues" functionality only runs on the first render
    const hasMounted = useRef(false);
    useEffect(() => {
        hasMounted.current = true;
    }, []);

    const handleChange = (vals, meta) => {
        let newValue = (vals === null ? [] : vals);
        setValue(newValue);
        onChange('units', newValue);
    }

    const promiseOptions = inputValue =>
        new Promise(resolve => {
            let url = API.getUrl(props.module, `components/select/units/${props.actionContext}`);
            let params = {
                search: inputValue,
                ...(props.blockIds.length && { block_ids: props.blockIds })
            };

            axios.get(url, { params})
                .then(res => {
                    const options = res.data.results;

                    if (preserveSelectedValues && !hasMounted.current) {
                        const allOptions = [
                            ...value.filter(val => !options.some(option => option.value === val.value)),
                            ...options,
                        ];
                        resolve(allOptions);
                    } else {
                        const filteredValue = value.filter(val => options.some(option => option.value === val.value));
                        if (filteredValue.length !== value.length) {
                            handleChange(filteredValue);
                        }
                        resolve(options);
                    }
                });
        });

    return (
        <AsyncSelect
            className="react-select-container"
            isMulti={multi}
            defaultOptions={true}
            loadOptions={promiseOptions}
            onChange={handleChange}
            value={value}
            placeholder=""
            styles={styles}
            theme={theme}
            // Use the key prop to force the options to reload when the block ids change
            key={props.blockIds.join('x')}
        />
    )
}

UnitSelector.propTypes = {
    module: PropTypes.string.isRequired,
    multi: PropTypes.bool,
    selected: PropTypes.array,
    actionContext: PropTypes.string,
    blockIds: PropTypes.array,
    preserveSelectedValues: PropTypes.bool,
}

UnitSelector.defaultProps = {
    multi: false,
    selected: [],
    actionContext: 'add',
    blockIds: [],
    preserveSelectedValues: false,
}

export default UnitSelector;
